import types from './constants'

export default {
  [types.READINGROPE_PENDING]: () => ({
   type: types.READINGROPE_PENDING,
  }),
  [types.READINGROPE_COMPLETE]: (report, activities) => ({
   type: types.READINGROPE_COMPLETE,
   report,
  }),
  [types.READINGROPE_ERROR]: (error) => ({
   type: types.READINGROPE_ERROR,
   error
  }),
}